export default __webpack_public_path__ + "static/media/5-1.6f24d5c2.webp";